import React from 'react';
import { Context } from '../model/elements';
import { ProviderAuthType } from '../model/types';

const CustomContext: React.Context<Context> = React.createContext({
    updateAuth: () => {},
    updateProviderAuths: (providerAuths: ProviderAuthType[]) => {},
    providerAuths: [] as ProviderAuthType[],
});
export default CustomContext;
